export default async function resolveStylesheetsContent(stylesheets) {
	try {
		const errorText = `<title>Error</title>`;
		const responses = await Promise.all(stylesheets.map(stylesheet => fetch(stylesheet)));
		let text = await Promise.all(responses.map(response => response.text()));
		text = text.filter(t => !t.includes(errorText));
		return text.join(' ');
	} catch (e) {
		return '';
	}
}
